<template>
  <div class="header">
    <def-bar />
    <div class="notice" v-if="noticeData && noticeData.noticeContent">
      <div class="notice__wrapper">
        <notice :noticeData="noticeData" :noticeInit="noticeInit">
          <span class="notice__label" slot="noticeLabel">
            <i class="notice__icon"></i>
          </span>
        </notice>
      </div>
    </div>
    <def-body />
  </div>
</template>

<script>
import DefBar from "./DefBar";
import DefBody from "./DefBody";
export default {
  components: {
    DefBar,
    DefBody,
    Notice: () => import("./Notice")
  },
  data() {
    return {
      noticeData: null,
      noticeInit: {
        color: "#3d96e2",
        col1: 1,
        col2: 23
      }
    };
  },
  created() {
    this.getNoticeData();
  },
  methods: {
    getNoticeData() {
      this.apis.headerApi.getNotice().then(res => {
        this.noticeData = res;
      });
    }
  }
};
</script>

<style lang="less" scoped>
.notice {
  line-height: 20px;
  padding-top: 10px;
  padding-bottom: 10px;
  background-color: #f5f9fd;
  font-weight: 500;
  &__wrapper {
    .wrapper();
  }
  &__label {
    > span {
      margin-left: 5px;
      font-size: 14px;
    }
  }
  &__icon {
    display: inline-block;
    vertical-align: top;
    background: url("./imgs/horn@2x.png") no-repeat;
    background-size: cover;
    width: 20px;
    height: 20px;
  }
}
</style>
